var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.92 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.45,28H43.12V38.5H28v2.33A1.16,1.16,0,0,0,29.13,42H42l4.66,4.67V29.17A1.17,1.17,0,0,0,45.45,28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.79,35V24.5a1.18,1.18,0,0,0-1.17-1.17H24.47a1.17,1.17,0,0,0-1.16,1.17V40.83L28,36.17H39.62A1.18,1.18,0,0,0,40.79,35Z"
  })));
}

export default SvgMessage;